export const openPackingSlip = (ids) => {
    const normalizedIds = Array.isArray(ids) 
      ? ids.map(id => Number(id))
      : [Number(ids)];
    const baseUrl = '/packingslip';
    const state = encodeURIComponent(JSON.stringify({ ids: normalizedIds }));
    const url = `${baseUrl}?state=${state}`;
    window.open(url, '_blank');
  };